import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import "./plan-aspect-button.scss"
import { useAutorepeat } from "hooks/auto-repeat"

// Timers for the auto-repeat when the mouse button is held down
const firstRepeatTime = 400
const subRepeatTime = 150

// A rounded button used with plan aspects that auto-repeats when the mouse is held down
const PlanAspectButton = ({ symbol, subText, onClick, isActive }) => {
  const [startRepeat, stopRepeat] = useAutorepeat(
    onClick,
    firstRepeatTime,
    subRepeatTime,
    isActive,
    false
  )

  return (
    <div
      className={classnames("plan-aspect--button", {
        "plan-aspect--button--disabled": !isActive
      })}
    >
      <div
        className="plan-aspect--button--main"
        onMouseDown={startRepeat}
        onMouseUp={stopRepeat}
        onMouseOut={stopRepeat}
      >
        {symbol}
      </div>
      <div className="plan-aspect--button--subtext">{subText}</div>
    </div>
  )
}

PlanAspectButton.propTypes = {
  symbol: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired
}

export default PlanAspectButton
